import { ConsoleTransporter } from '../transporters/console-transporter.service';
import { Transporter } from '../transporters/transporter.model';
import { LogLevel } from './log-levels.enum';
import { LoggerConfiguration } from './logger-config.model';
import { Logger } from './logger.service';

/**
 * default logger config
 */
const _loggerConfig: any = {
  level: LogLevel.Error,
};

let _transporters: Array<Transporter<any>> = [new ConsoleTransporter()];

/**
 * logger instance holder
 */
let _logger: any;

/**
 * Singleton vanilla Logger factory
 */
const LoggerFactory = {
  /**
   * Configurator method
   */
  configure: <T>(config: LoggerConfiguration, transports: Array<Transporter<T>>) => {
    _loggerConfig.level = config.level;
    if (Array.isArray(transports) && transports.length > 0) {
      _transporters = transports;
    }
    // to dispose default logger instance created
    _logger = undefined;
  },

  /**
   * Returns last configured logger
   */
  getLogger: <T>(): Logger<T> => {
    if (!_logger) {
      _logger = new Logger<T>(_loggerConfig, _transporters);
    }
    return _logger;
  },
};

/**
 * export Singleton object
 */
Object.freeze(LoggerFactory);
export default LoggerFactory;
